import React, { ChangeEvent } from "react";
import { Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { hasErrorsApi } from "go-core";
import { ApiError } from "go-core/api/types";
import { FormErrorMessageApi } from "go-form/components/FormErrorMessage";
import { CreateOrganizationApi, RegisterUserApi } from "../../../../services/Security/types";

interface Props {
	loading: boolean;
	errors: ApiError[];
	setOrganization: React.Dispatch<React.SetStateAction<CreateOrganizationApi>>;
	organization: CreateOrganizationApi;
	setValues: React.Dispatch<React.SetStateAction<RegisterUserApi>>;
	values: RegisterUserApi;
}

const AuthenticatedRegisterForm = ({ loading, errors, setOrganization, organization, setValues, values }: Props) => {
	const { t } = useTranslation();

	const handleOrganizationChange = (prop: keyof CreateOrganizationApi) => (event: ChangeEvent<HTMLInputElement>) => {
		setOrganization({
			...organization,
			[prop]:
				event.target.type === "text" || event.target.type === "password"
					? event.target.value
					: event.target.checked,
		});
	};

	const handleCategoryChange = (prop: keyof CreateOrganizationApi) => (event: any) => {
		setOrganization({ ...organization, [prop]: event.target.value });
	};

	return (
		<>
			<Form.Group className="form-group">
				<Form.Control
					disabled={loading}
					id="organization_name"
					isInvalid={hasErrorsApi(errors, "name")}
					onChange={handleOrganizationChange("name")}
					type="text"
					value={organization.name}
					placeholder={t("modules.security.field.company_name.title")}
				/>
				<Form.Label htmlFor="organization_name" sm={3}>
					{`${t("modules.security.field.company_name.title")}*`}
				</Form.Label>
				<FormErrorMessageApi errors={errors} field="name" />
			</Form.Group>
			<Form.Group className="form-group">
				<Form.Control
					as="select"
					id="category"
					onChange={handleCategoryChange("category")}
					isInvalid={hasErrorsApi(errors, "category")}
				>
					<option value="">{t("modules.security.field.choose_category.title")}</option>
					<option value="CLUB">{t("enums.organization_category.CLUB")}</option>
					<option value="RESTAURANT">{t("enums.organization_category.RESTAURANT")}</option>
					<option value="CAFE">{t("enums.organization_category.CAFE")}</option>
					<option value="FOODTRUCK">{t("enums.organization_category.FOODTRUCK")}</option>
					<option value="PUB_BAR">{t("enums.organization_category.PUB_BAR")}</option>
					<option value="SUSHI">{t("enums.organization_category.SUSHI")}</option>
					<option value="SHOP">{t("enums.organization_category.SHOP")}</option>
					<option value="OTHERS">{t("enums.organization_category.OTHERS")}</option>
				</Form.Control>
				<Form.Label htmlFor="category" sm={3}>
					{t("modules.security.field.category.title")}
				</Form.Label>
				<FormErrorMessageApi errors={errors} field="category" />
			</Form.Group>
			<Form.Group className="form-group">
				<Form.Check
					required
					type="checkbox"
					name="accept_terms"
					onChange={(e) => {
						setOrganization({
							...organization,
							accept_privacy: e.target.checked,
							accept_terms: e.target.checked,
							accept_rules: e.target.checked,
						});
					}}
					label={
						<>
							{t("modules.security.field.accept.title")}
							<a href="https://www.gopos.pl/tos">{t("modules.security.field.tos.title")}</a>,{" "}
							<a href="https://www.gopos.pl/privacy-policy">
								{t("modules.security.field.privacy_policy.title")}
							</a>{" "}
							{`${t("modules.security.field.receive_informations_from_gopos.title")} *`}
						</>
					}
					isInvalid={hasErrorsApi(errors, "accept_terms")}
					feedback={t("constraints.must_accept")}
					id="accept_terms"
				/>
			</Form.Group>
			<Form.Group className="form-group">
				<Form.Check
					required
					type="checkbox"
					name="accept_marketing_content"
					onChange={(e) => {
						setValues({ ...values, accept_marketing_content: e.target.checked });
					}}
					label={<>{t("modules.security.field.accept_marketing_content.title")}</>}
					isInvalid={hasErrorsApi(errors, "accept_marketing_content")}
					id="accept_marketing_content"
				/>
			</Form.Group>
		</>
	);
};

export default AuthenticatedRegisterForm;
